import { LegendItem } from "helpers/models";

export default (legendItems: LegendItem[]) => {
  const layerRuleOrder: { [key: string]: string[] } = {};
  legendItems.forEach((item) => {
    if (item.layerId && item.rules) {
      layerRuleOrder[item.layerId] = item.rules.map((rule) => rule.title);
    }
  });
  return layerRuleOrder;
};
